import { useContext } from "react";
import { ChemicalFormulaContext } from "../contexts/formulaprovider";
import { calcFormulaWeight } from "../calcfw";
import { SPFormulaWeight, SFormulaWeight } from "./styled";

export const FormulaWeight = () => {
  const { elements } = useContext(ChemicalFormulaContext);
  let fw = 0.0;

  if (elements !== null) {
    fw = calcFormulaWeight(elements);
  }

  return (
    <SPFormulaWeight>
      式量 = <SFormulaWeight>{parseInt(fw * 1000 + 0.5) / 1000}</SFormulaWeight>
    </SPFormulaWeight>
  );
};
